'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleAnalytics4 = function () {
  function GoogleAnalytics4() {
    (0, _classCallCheck3.default)(this, GoogleAnalytics4);

    var meta = document.querySelector('meta[name="ga4"]');
    if (!meta) {
      return;
    }

    this.currency = Shopify.currency.active;
    this.brand = "Jimmy Lion";

    if (window.theme && window.theme.vuex) {
      this.store = window.theme.vuex;
      this.processImpressionsInterval = 2000;
      this.processImpressionsQueueInitiated = false;
    }
    this.initEventListeners();
  }

  (0, _createClass3.default)(GoogleAnalytics4, [{
    key: 'initEventListeners',
    value: function initEventListeners() {
      document.addEventListener('theme:ga4-event', this.processEvent.bind(this));
      document.addEventListener('theme:load-checkout', this.checkoutEvent.bind(this));
      document.addEventListener('theme:add-paymend-info', this.addPaymentInfoEvent.bind(this));
      document.addEventListener('theme:order-confirmation', this.orderConfirmationEvent.bind(this));
      document.addEventListener('theme:ga4-needs-queue-processing', this.initImpressionsProcessing.bind(this));
    }
  }, {
    key: 'addPaymentInfoEvent',
    value: function addPaymentInfoEvent(event) {
      var eventData = event.detail;
      var items = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = eventData.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var lineItem = _step.value;

          var item = this.lineItemToGA4Item(lineItem, false);
          if (item) {
            items.push(item);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      eventData.items = items;

      if (items.length) {
        this.sendEvent('add_payment_info', eventData);
      } else {
        console.error('GA4 addPaymentInfoEvent: no proper items to send', event.detail);
      }
    }
  }, {
    key: 'orderConfirmationEvent',
    value: function orderConfirmationEvent(event) {
      var eventData = event.detail;
      var items = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = eventData.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var lineItem = _step2.value;

          var item = this.lineItemToGA4Item(lineItem, false);
          if (item) {
            items.push(item);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      eventData.items = items;

      if (items.length) {
        this.sendEvent('purchase', eventData);
      } else {
        console.error('GA4 checkoutEvent: no proper items to send', event.detail);
      }
    }
  }, {
    key: 'initImpressionsProcessing',
    value: function initImpressionsProcessing() {
      var _this = this;

      if (this.processImpressionsQueueInitiated || !this.store) {
        return;
      }
      this.processImpressionsQueueInitiated = true;

      setInterval(function () {
        _this.processImpressionsQueue();
      }, this.processImpressionsInterval);
    }
  }, {
    key: 'processImpressionsQueue',
    value: function processImpressionsQueue() {
      if (!this.store.state.analytics.impresionsQueued.length) return;

      var GA4Event = new CustomEvent('theme:ga4-event', {
        detail: {
          items: this.store.state.analytics.impresionsQueued,
          eventType: 'view_item_list',
          itemType: 'product'
        }
      });
      document.dispatchEvent(GA4Event);
      this.store.commit('clearImpresionQueue');
    }
  }, {
    key: 'sendEvent',
    value: function sendEvent(eventType, eventData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: eventType,
        ecommerce: eventData
      });
    }
  }, {
    key: 'processEvent',
    value: function processEvent(event) {
      if (!event.detail || !event.detail.eventType || !event.detail.itemType || !event.detail.items || !event.detail.items.length) {
        console.error('GA4 processEvent: malformed event object', event.detail);
        return;
      }

      var items = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = event.detail.items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var rawItem = _step3.value;

          var item = void 0;
          if (event.detail.itemType == 'product') {
            item = this.productToGA4Item(rawItem);
            if (item) {
              items.push(item);
            }
          } else if (event.detail.itemType == 'lineItem') {
            if (rawItem.itemType == 'pack' && rawItem.childs) {
              item = this.lineItemToGA4Item(rawItem.parent);
              if (item) {
                items.push(item);
              }
              item = this.lineItemToGA4Item(rawItem.packaging);
              if (item) {
                items.push(item);
              }
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = rawItem.childs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var child = _step4.value;

                  item = this.lineItemToGA4Item(child);
                  if (item) {
                    items.push(item);
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            } else {
              item = this.lineItemToGA4Item(rawItem);
              if (item) {
                items.push(item);
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (items.length) {
        this.sendEvent(event.detail.eventType, { items: items });
      } else {
        console.error('GA4 processEvent: no properly formed items to send', event.detail);
      }
    }
  }, {
    key: 'checkoutEvent',
    value: function checkoutEvent(event) {
      if (!event.detail.step || !event.detail.items || !event.detail.items.length) {
        console.error('GA4 checkoutEvent: no proper items to send', event.detail);
        return;
      }

      var checkoutStepToEventName = {
        "contact_information": "begin_checkout",
        'payment_method': "add_shipping_info",
        "processing": "add_payment_info"
      };

      if (!checkoutStepToEventName[event.detail.step]) {
        return;
      }

      var eventName = checkoutStepToEventName[event.detail.step];

      var items = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = event.detail.items[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var lineItem = _step5.value;

          var item = this.lineItemToGA4Item(lineItem);
          if (item) {
            items.push(item);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (items.length) {
        var eventObject = { items: items };
        if (eventName == 'add_shipping_info' && event.detail.shipping_tier) {
          eventObject = Object.assign({}, eventObject, { shipping_tier: event.detail.shipping_tier });
        } else if (eventName == 'add_payment_info' && event.detail.payment_type) {
          eventObject = Object.assign({}, eventObject, { payment_type: event.detail.payment_type });
        }
        this.sendEvent(eventName, eventObject);
      } else {
        console.error('GA4 checkoutEvent: no proper items to send', event.detail);
      }
    }
  }, {
    key: 'productToGA4Item',
    value: function productToGA4Item(product) {
      if (!product.handle || !product.title) {
        console.error('GA4 productToGA4Item: cannot process product');
        return false;
      }

      var categoriesObject = this.generateCategories(product);

      var item = Object.assign({
        item_name: product.title,
        item_id: product.id,
        price: product.price / 100,
        currency: this.currency,
        item_brand: this.brand
      }, categoriesObject);

      if (product.item_list_name) {
        item.item_list_name = product.item_list_name;
      }

      if (product.item_list_id) {
        item.item_list_id = product.item_list_id;
      }

      if (product.index) {
        item.index = product.index;
      }

      /*
      if (product.main_category) {
        item.item_category = product.main_category;
      }
       if (product.length) {
        item.item_category2 = product.length;
      }
       if (product.style) {
        item.item_category3 = product.style;
      }
       if (product.limited_edition) {
        item.item_category4 = product.limited_edition;
      }
      */

      return item;
    }
  }, {
    key: 'lineItemToGA4Item',
    value: function lineItemToGA4Item(lineItem) {
      var dividePrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!lineItem.product_id) {
        console.error('GA4 lineItemToGA4Item: cannot process lineItem', lineItem);
        return false;
      }

      var categoriesObject = this.generateCategories(lineItem);

      var item = Object.assign({
        item_name: lineItem.product_title || lineItem.title,
        item_id: lineItem.product_id,
        price: dividePrice ? lineItem.line_price / 100 : lineItem.line_price,
        currency: this.currency,
        item_brand: this.brand,
        item_variant: lineItem.variant_title,
        quantity: lineItem.hasOwnProperty('quantity') ? lineItem.quantity : 1
      }, categoriesObject);

      /*
      if (lineItem.main_category) {
        item.item_category = lineItem.main_category;
      }
       if (lineItem.length) {
        item.item_category2 = lineItem.length;
      }
       if (lineItem.style) {
        item.item_category3 = lineItem.style;
      }
       if (lineItem.limited_edition) {
        item.item_category4 = lineItem.limited_edition;
      }
      */

      return item;
    }
  }, {
    key: 'generateCategories',
    value: function generateCategories(item) {
      var categories = [];

      if (item.main_category) {
        categories.push(item.main_category);
      }

      if (item.length) {
        categories.push(item.length);
      }

      if (item.style) {
        categories.push(item.style);
      }

      if (item.limited_edition) {
        categories.push(item.limited_edition);
      }

      var categoriesObject = {};
      var index = 1;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = categories[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var category = _step6.value;

          var categoryKey = 'item_category' + (index == 1 ? '' : index);
          categoriesObject[categoryKey] = category;
          index++;
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return categoriesObject;
    }
  }]);
  return GoogleAnalytics4;
}();

/*
✓ view_item_list
✓ select_item
✓ view_item
✓ add_to_cart
✓ remove_from_cart
✓ view_cart
✓ begin_checkout
✓ add_shipping_info
✓ add_payment_info
✓ purchase

TODOS 
- añadir kill switch en src/snippets/checkout-head-scripts-styles.liquid

DUDAS
- Envíamos padre y packaging del pack?
- eventos del checkout no se pueden evniar como piden
- enviamos order_id o order_name como transaction_id ? 


PRUEBAS
Related products
Product carousel
Product grid
Collection
Pack Creator
Search

*/


exports.default = GoogleAnalytics4;